export enum MessageType {
    AuthorizationRequest = "AuthorizationRequest",
    AuthorizationSuccess = "AuthorizationSuccess",
    AuthorizationFailure = "AuthorizationFailure",
    Unknown = "Unknown",
    DataIntegratorRunPartStarted = "DataIntegratorRunPartStarted",
    DataIntegratorRunPartFinished = "DataIntegratorRunPartFinished",
    SolverRunPartStarted = "SolverRunPartStarted",
    SolverRunPartFinished = "SolverRunPartFinished",
    ParsingError = "ParsingError"
}